import React from "react";
import {createRoot} from "react-dom/client";

import { BrowserRouter} from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css"; 
import "./assets/css/animate.min.css";
import "./assets/scss/light-bootstrap-dashboard-react.scss?v=2.0.0";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { AuthProvider } from "auth";
import {AppRouter} from "router/AppRouter"

const container=document.getElementById("root")
const root = createRoot(container); 

root.render(
  <AuthProvider>
    <BrowserRouter>
    <AppRouter></AppRouter>
    </BrowserRouter>
  </AuthProvider>
    
);
